import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { uuidv4 } from '../../../../shared/utils';
import { Input } from '@maxmilhas/hangar-components-atomic/public';

export const CheckboxGroup = ({ options, onChange, value, ...rest }) => {
  const [selected, setSelected] = useState([]);

  const optionIsString = (option) => typeof option === 'string';

  const handleChecked = (checked, option) => {
    const arr = [...selected];
    const opt = optionIsString(option) ? option : option.value;
    const index = arr.indexOf(opt);

    if (checked) {
      arr.push(opt);
    } else {
      arr.splice(index, 1);
    }

    setSelected(arr);
  };

  const checkIfIsChecked = option => {
    const opt = optionIsString(option) ? option : option.value;
    return selected.includes(opt);
  };

  useEffect(() => {
    onChange(selected);
  }, [selected]);

  return (
    options.map(option => (
      <div key={uuidv4()}>
        <Input
          {...rest}
          id={uuidv4()}
          type="checkbox"
          label={optionIsString(option) ? option : option.label}
          disabled={optionIsString(option) ? false : option.disabled}
          checked={checkIfIsChecked(option)}
          onChange={e => handleChecked(e.target.checked, option)}
        />
      </div>
    ))
  );
};

CheckboxGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
      disabled: PropTypes.bool
    })
  ])),
  value: PropTypes.any,
  onChange: PropTypes.func
};

CheckboxGroup.defaultProps = {
  options: [],
  onChange: () => undefined
}

export default CheckboxGroup;
